export default {
  getSalonsOverview(state) {
    return state.salonsOverview;
  },
  getSalonDetailedReport(state) {
    return state.salonDetailedReport;
  },
  getSalariesReport(state) {
    return state.salariesReport;
  },
  getDiscountSummary(state) {
    return state.discountSummary;
  },
  getSalonDailyReports(state) {
    return state.salonDailyReports;
  },
  getTodayPaymentsReport(state) {
    return state.todayPaymentsReport
  }
}
